import React from 'react'
import { Accordion } from 'react-bootstrap'
import { MathJaxContext, MathJax } from 'better-react-mathjax'
import 'style/component/util/mathjaxContent.css'

const mathjaxConfig = {
    loader: { load: ['input/tex', 'output/chtml'] },
    tex: {
        inlineMath: [['$', '$']],
        displayMath: [['$$', '$$']],
    },
    options: {
        enableMenu: false, // Disable the right-click context menu
    },
}

const nl2br = (text) => text ? text.replace(/(?:\r\n|\r|\n)/g, '<br />') : ""

export const MathjaxContentWrapper = ({ children }) => <MathJaxContext version={3} config={mathjaxConfig}>
    {children}
</MathJaxContext>;

export const MathjaxContent = ({ content }) => {
    return <div tabIndex={-1}>
        <MathJax dynamic>
            <div className='mathjax-img-context'>
                <div dangerouslySetInnerHTML={{ __html: nl2br(content) }}></div>
            </div>
        </MathJax>
    </div>
}

export const MathjaxCollapsible = ({ label, content }) => {
    return <Accordion>
        <Accordion.Item eventKey='0'>
            <Accordion.Header className='mathjax-content-header'>{label}</Accordion.Header>
            <Accordion.Body>
                <MathjaxContent content={content} />
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>;
}